import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ListaLinksScroleable.module.css';

const ListaLinksScroleable = (props) => {
  const path = props.path;
  const lista = props.lista;
  const cantVisibles = props.cantVisibles;
  const altoFijo = props.altoFijo;
  const alto = cantVisibles ? cantVisibles * 28 : 280; // 10 items por defecto

  return (
    <div
      className={`${styles.scrollContainer}`}
      style={{
        maxHeight: `${alto}px`,
        overflowY: 'auto',
        minHeight: `${altoFijo ? alto + 'px' : 'auto'}`,
      }}
    >
      {lista &&
        lista.map((item) => (
          <Link className={`${styles.listItem}`} key={item.id} to={path + item.id}>
            {item.descripcion ? item.descripcion : item.nombre}
          </Link>
        ))}
    </div>
  );
};

export default ListaLinksScroleable;
